import { useGetMasterSystemAdminSupportEmail } from '../../shared/react-query-hooks/useGetMasterSystemAdminSupportEmail';

export const MailToSystemAdminSupportLink = () => {
    const masterSystemAdminSupportEmailRespone = useGetMasterSystemAdminSupportEmail();
    const mailTo = `mailto:${masterSystemAdminSupportEmailRespone?.data ?? ''}`;
    
    return <a href={mailTo}>{masterSystemAdminSupportEmailRespone?.data}</a>;
};
